export default "__VITE_ASSET__D9iDFQ2Y__"